// src/hooks/useAuthentication.js
import { useAuthenticationContext } from "../contexts";

export function useAuthentication() {
  const {
    user,
    isAuthenticated,
    loading,
    error,
    signIn,
    signOut,
    checkAuthenticationStatus,
    clearError,
  } = useAuthenticationContext();

  return {
    // State
    user,
    isAuthenticated,
    loading,
    error,
    
    // Actions
    signIn,
    signOut,
    checkAuthStatus: checkAuthenticationStatus,
    clearError,
    
    // User properties
    userUid: user?.uid || null,
    userEmail: user?.email || null,
    userFirstName: user?.firstName || null,
    userLastName: user?.lastName || null,
    userFullName: user?.firstName && user?.lastName 
      ? `${user.firstName} ${user.lastName}` 
      : user?.firstName || null,
    userBirthday: user?.birthday || null,
    userGender: user?.gender || null,
    userEmailVerified: user?.emailVerified || false,
    
    // Settings
    userSettings: user?.settings || { theme: 'light', notifications: { email: true } },
    userTheme: user?.settings?.theme || 'light',
    userNotifications: user?.settings?.notifications || { email: true },
    
    // Computed
    hasError: !!error,
  };
}